import type { Expense } from "./types";

export function generateNarrative(
  expense: Expense,
  allExpenses: Expense[],
  hasReceipt: boolean,
): string {
  const amount = expense.amountCents / 100;
  const category = expense.categoryLabel ?? null;
  const policy = expense.taxPolicyLabel ?? null;
  const hasPurpose = Boolean(expense.businessPurpose?.trim());

  const vendorNorm = expense.vendor.toLowerCase().trim();
  const priorCount = allExpenses.filter(
    (e) => e.id !== expense.id && e.vendor.toLowerCase().trim() === vendorNorm,
  ).length;

  const parts: string[] = [];

  if (category) {
    if (priorCount >= 2) {
      parts.push(
        `Categorized as ${category} — consistent with ${priorCount} prior ${expense.vendor} purchase${priorCount !== 1 ? "s" : ""}`,
      );
    } else {
      parts.push(`Categorized as ${category}`);
    }
  } else {
    parts.push("Category not assigned — add one to improve your audit score");
  }

  if (policy) {
    const deductible = expense.deductibleAmountCents;
    if (deductible !== null && expense.amountCents > 0) {
      const pct = Math.round((deductible / expense.amountCents) * 100);
      parts.push(`${pct}% deductible under ${policy}`);
    } else {
      parts.push(`Policy: ${policy}`);
    }
  }

  if (!hasReceipt && amount > 25) {
    parts.push("receipt required for IRS documentation");
  }

  const catLower = category?.toLowerCase() ?? "";
  if (!hasPurpose && (catLower.includes("meal") || catLower.includes("entertainment"))) {
    parts.push("add a business purpose — IRS requires it for meals/entertainment");
  }

  return parts.join("; ") + ".";
}
